/**
 * Aperçu LOCAL d'une photo de profil en attente d'analyse antivirus.
 *
 * Le serveur ne sert un fichier qu'une fois déclaré sain (§15.4, Q131). Entre
 * l'envoi et le verdict, il n'y a rien à afficher : l'interface restait donc
 * sur les initiales, exactement comme si l'envoi avait échoué — au point qu'on
 * recharge la page en croyant à un bug. On montre l'image que l'utilisateur
 * vient de choisir, depuis SON navigateur, jusqu'à ce que la version contrôlée
 * prenne le relais.
 *
 * Un aperçu n'est jamais une preuve : il ne vient pas du serveur, il ne
 * franchit pas l'onglet, et il disparaît au rechargement. La pastille porte
 * pendant ce temps un état « analyse en cours » explicite.
 *
 * Magasin externe minimal plutôt qu'un état React : la même photo doit
 * apparaître AU MÊME INSTANT dans la barre haute, la colonne de navigation, la
 * feuille du menu et la fiche personnel, qui ne partagent aucun parent.
 */
const previews = new Map<string, string>();
const listeners = new Set<() => void>();
let version = 0;

function notify(): void {
  version += 1;
  for (const listener of listeners) listener();
}

/** Retient l'image choisie, le temps que l'analyse aboutisse. */
export function rememberAvatarPreview(fileId: string, file: Blob): void {
  forgetAvatarPreview(fileId);
  previews.set(fileId, URL.createObjectURL(file));
  notify();
}

/** Libère l'URL objet : sans cela, le blob reste en mémoire pour l'onglet. */
export function forgetAvatarPreview(fileId: string): void {
  const url = previews.get(fileId);
  if (!url) return;
  URL.revokeObjectURL(url);
  previews.delete(fileId);
  notify();
}

export function avatarPreviewUrl(fileId: string | null | undefined): string | undefined {
  return fileId ? previews.get(fileId) : undefined;
}

export function subscribeAvatarPreviews(listener: () => void): () => void {
  listeners.add(listener);
  return () => void listeners.delete(listener);
}

/**
 * Instantané pour `useSyncExternalStore`, qui compare par identité : un
 * compteur scalaire est stable tant que rien ne change, là où renvoyer la Map
 * provoquerait une boucle de rendu.
 */
export function avatarPreviewsVersion(): number {
  return version;
}
